// Utility dialogs only - config panels are used instead of part-specific config dialogs
export * from './confirm-dialog.component';
